import { Attachment } from './Attachment.client';
import { Markdown } from './Markdown';
import { FileSelections } from '~/components/chat/FileSelections.client';
import type { InspectedElement } from '~/lib/stores/workbench';
import type { FileSelection, SimpleAttachment } from '~/types/chat';
import { classNames } from '~/utils/classNames';
import { isInspectedImage } from '~/utils/inspect-element';

interface UserMessageProps {
  content: string;
  className?: string;
  renderHtml?: boolean;
  attachments?: Array<SimpleAttachment>;
  fileSelections?: FileSelection[];
  inspectedElement?: InspectedElement;
}

export function UserMessage({
  content,
  renderHtml,
  attachments,
  fileSelections,
  className,
  inspectedElement,
}: UserMessageProps) {
  if (inspectedElement) {
    attachments = attachments?.filter((attachment) => !isInspectedImage(attachment.name ?? ''));
  }

  return (
    <div className={classNames('overflow-hidden', className)}>
      {attachments && attachments.length > 0 && (
        <>
          <div className="flex gap-3.5 mb-4">
            {attachments?.map((attachment) => {
              return <Attachment key={attachment.url} attachment={attachment} />;
            })}
          </div>
        </>
      )}

      {inspectedElement && (
        <div className="inline-block mb-4 rounded border border-bolt-elements-borderColor bg-bolt-elements-background-depth-2 text-xs">
          <div className="flex flex-col py-1.5 px-2.5 font-medium">
            <div className="flex justify-between items-center">
              <div>{`<${inspectedElement.tagName}> selected for inspection`}</div>
            </div>
          </div>
        </div>
      )}

      <FileSelections
        className="mb-4"
        itemClassName="bg-bolt-elements-messages-selections-background"
        buttonClassName="text-bolt-elements-messages-selections-text hover:text-bolt-elements-messages-selections-textHover"
        fileSelections={fileSelections}
      />

      <Markdown limitedMarkdown={!renderHtml} html={renderHtml}>
        {content}
      </Markdown>
    </div>
  );
}
